export enum CopyTypes {
    ALL,
    SPECIFIC,
}
